
import { computed, defineComponent } from 'vue';
import { useStore } from 'vuex';
import { Container, Loading } from '@/components/bosons';
import { SearchForm, PokemonCard } from '@/components/molecules';

export default defineComponent({
  name: 'Component',
  components: {
    Container,
    SearchForm,
    PokemonCard,
    Loading,
  },
  setup() {
    const store = useStore();
    const loading = computed(() => store.state.loading);
    const pokemons = computed(() => store.state.pokemons);

    return {
      loading,
      pokemons,
    };
  },
});
